import React, { useState, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { BASE_URL, BASE_URL_PREBID } from "./axios";
import { ToastContainer, toast } from "react-toastify";
import { UpdatePencil, UpdatePencilWhite, DropdownArrow, SearchBig, AddwithWhiteCircle, DeleteDustbin, CrosswithGreyCircle } from "../../utils/ReusableSVGs";
import { Modal } from 'react-bootstrap';
// import Createnewall from "../Modals/Createnewall";
import { handleErrorToast } from "../../utils/ReusableFunctions";
import Select from "react-select";

const AddActivity = ({ projectID,
    department_name,
    getDepartmentList, weightage }) => {
    const [fileNames, setFileNames] = useState([]);
    console.log(weightage, 'weightage')
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        activity_name: '',
        activity_type: 'internal',
        activity_description: '',
        project_detail: projectID ? projectID : "",
        department: department_name ? department_name : "",
        activity_parent: '',
        assigned_by: '',
        assigned_to: [],
        weightage: '',
        assign_date: '',
        deadline_date: '',
        uploaded_file: "",
        vendor_name: '',
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            'activity_name',
            'activity_type',
            'weightage',
            // "assign_date",
            // "deadline_date",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)



    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = allActivity.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > weightage) {
                console.log("100")
                newErrors.weightage = `Total weightage cannot be exceeds  ${weightage} (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };





    const handleShow = () => {
        setShow(true);


    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }


    const [allEmployeeData, setAllEmployeeData] = useState([]);


    const [allActivity, setAllActivity] = useState([]);

    const fetchActivity = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/project-details/activityfilter-by-department/${department_name}/`);
            setAllActivity(res.data);
        } catch (err) {

        }
    };

    useEffect(() => {
        if (show) {
            getEmployeeDetails();
            fetchActivity()
        }

    }, [show]);



    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const assigned_to = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            assigned_to,
        }));
    };

    const handleFormSubmit = async (e) => {
        console.log("clicked")
        e.preventDefault();
        const newerror = {};

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const formDataToSend = new FormData();


                Object.keys(formData).forEach((key) => {
                    if (formData[key] && key !== "uploaded_file") {
                        formDataToSend.append(key, formData[key]);
                    }
                });




                const symbols = "!@#$%^&*()_-+=";
                const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const numbers = "0123456789";
                const now = new Date();
                const date = now
                    .toLocaleDateString("en-GB")
                    .split("/")
                    .reverse()
                    .join("-");
                const time = now
                    .toLocaleTimeString("en-GB", { hour12: false })
                    .replace(/:/g, "-");
                const allChars =
                    symbols + lowercaseLetters + uppercaseLetters + numbers;
                let randomCode = "";
                for (let i = 0; i < 8; i++) {
                    const randomIndex = Math.floor(Math.random() * allChars.length);
                    randomCode += allChars[randomIndex];
                }

                const originalFile2 = formData.uploaded_file;
                const customFileName2 = `Aimantra ${date} ${time}_${randomCode} ${originalFile2.name}`;
                const customFile2 = new File([originalFile2], customFileName2, {
                    type: originalFile2.type,
                });




                if (formData.uploaded_file) {
                    formDataToSend.append("uploaded_file", customFile2);
                }



                let res = await axios.post(
                    `${BASE_URL}/project-details/activitytype/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    const [vendorList, SetVendorList] = useState([]);
    const getAllVendor = async () => {

        try {
            const sub = await axios.get(`${BASE_URL}/detail-design/vendor/`);
            SetVendorList(sub.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {

        }
    };

    useEffect(() => {
        if (show) {
            getAllVendor()
        }
    }, [show])

    return (
        <>
            <button
                title="Add Detail Design"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Add Activity
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Activity</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_name"
                                    value={formData.activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.project_code ? 'error' : inputState.project_code ? 'success' : ''}`}
                                />
                                {errors.project_code && <span className="error-message">{errors.project_code}</span>}
                            </div>
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Type <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Activity Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>


                            <div className="flex-column">
                                <label className="form-labels">Activity Discription <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_description"
                                    value={formData.activity_description}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.activity_description ? 'error' : inputState.activity_description ? 'success' : ''}`}
                                />
                                {errors.activity_description && <span className="error-message">{errors.activity_description}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Parent <span className="required">*</span></label>



                                {allActivity.length === 0 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                    </div>
                                ) : (
                                    <>
                                        <select
                                            id="activity_parent"
                                            name="activity_parent"
                                            value={formData.activity_parent}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.activity_parent
                                                ? "error"
                                                : inputState.activity_parent
                                                    ? "success"
                                                    : ""
                                                }`}
                                        >
                                            <option value="">Select a Activity</option>
                                            {allActivity?.sort((a, b) => a?.activity_name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                <option key={index} value={i.id}>
                                                    {i?.activity_name}{/* Adjusted to show the structure name */}
                                                </option>
                                            ))}
                                        </select>
                                        <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors.department && (
                                                <span className="error-message font-size-text ">
                                                    {errors.department}
                                                </span>
                                            )}
                                        </div>
                                    </>
                                )}

                            </div>

                            {formData?.activity_type === "internal" ?
                                (
                                    <>
                                        <div title="assigned_by" className="flex-column form-group-selectt">
                                            <label htmlFor="assigned_by" className="form-labels font-weight500 font-size-subheading">
                                                Team Lead<span className="required">*</span>
                                            </label>

                                            {allEmployeeData.length === 0 ?
                                                <div className="form-loader">
                                                    <div className="bar-loader"></div>
                                                </div> :
                                                <>
                                                    <select
                                                        id="assigned_by"
                                                        name="assigned_by"
                                                        value={formData.assigned_by} // Changed from `project` to `team_lead`
                                                        onChange={handleInputChange}
                                                        className={`form-input form-group-selection ${errors.assigned_by ? "error" : inputState.assigned_by ? "success" : ""}`}

                                                    >
                                                        <option value="">Select Team Lead</option>
                                                        {allEmployeeData?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                            <option key={index} value={i.emp_code}>
                                                                {`${i.emp_code} - ${i.name}`} {/* Adjusted to show the structure name */}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        {errors.assigned_by && (
                                                            <span className="error-message font-size-text ">{errors.assigned_by}</span>
                                                        )}
                                                    </div>
                                                </>}
                                        </div>
                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Assigned To:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectEmployee}
                                                value={formData.assignedto?.map((code) => ({
                                                    value: code,
                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />

                                            {errors.employee && (
                                                <span className="error-message font-size-text ">{errors.employee}</span>
                                            )}
                                        </div>
                                    </>)
                                : (<>
                                    <div title="Vendor Name" className="flex-column form-group-selectt">
                                        <label htmlFor="vendor_name" className="form-labels  font-weight500    font-size-subheading">
                                            Select Existing Vendor <span className="required">*</span>
                                        </label>

                                        <select
                                            id="vendor_name"
                                            name="vendor_name"
                                            value={formData?.vendor_name}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.vendor_name ? "error" : inputState.vendor_name ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select a Vendor</option>
                                            {vendorList?.sort((a, b) => a?.name?.localeCompare(b.company_name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                {console.log(i)}
                                                <option value={i?.id}>{i?.name}</option>
                                            </>))
                                            }
                                        </select>
                                        <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors.vendor_name && (
                                                <span className="error-message font-size-text ">{errors.vendor_name}</span>
                                            )}
                                        </div>
                                    </div>
                                </>)}
                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>
                                    <div className="input-wrapper">
                                        <input
                                            type="date"
                                            id="assign_date"
                                            value={formData.assign_date}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                        />
                                        <div className="icon-wrapper">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.2498 2.23341H12.8498V1.08341C12.8498 0.946386 12.7954 0.81497 12.6985 0.718076C12.6016 0.621183 12.4702 0.566748 12.3332 0.566748C12.1961 0.566748 12.0647 0.621182 11.9678 0.718076C11.8709 0.81497 11.8165 0.946387 11.8165 1.08341V2.23341H6.18317V1.08341C6.18317 0.946387 6.12874 0.81497 6.03184 0.718076C5.93495 0.621182 5.80353 0.566748 5.6665 0.566748C5.52948 0.566748 5.39806 0.621182 5.30117 0.718076C5.20427 0.81497 5.14984 0.946386 5.14984 1.08341V2.23341H2.74984L2.74972 2.23341C2.17091 2.23411 1.616 2.46435 1.20672 2.87363C0.797436 3.28291 0.567197 3.83782 0.566504 4.41663V4.41675L0.566504 15.2501L0.566504 15.2502C0.567197 15.829 0.797436 16.3839 1.20672 16.7932C1.616 17.2025 2.17091 17.4327 2.74972 17.4334H2.74984H15.2498C15.8289 17.4334 16.3842 17.2034 16.7937 16.7939C17.2031 16.3845 17.4332 15.8291 17.4332 15.2501V4.41675C17.4332 3.83769 17.2031 3.28235 16.7937 2.8729C16.3842 2.46344 15.8289 2.23341 15.2498 2.23341ZM16.3998 15.2501C16.3998 15.5551 16.2787 15.8476 16.063 16.0633C15.8473 16.2789 15.5548 16.4001 15.2498 16.4001H2.74984C2.44484 16.4001 2.15233 16.2789 1.93666 16.0633C1.721 15.8476 1.59984 15.5551 1.59984 15.2501V8.26675H16.3998V15.2501ZM16.3998 7.23341H1.59984V4.41675C1.59984 3.78189 2.11349 3.26675 2.74984 3.26675H5.14984V4.41675C5.14984 4.55378 5.20427 4.68519 5.30117 4.78209C5.39806 4.87898 5.52948 4.93341 5.6665 4.93341C5.80353 4.93341 5.93495 4.87898 6.03184 4.78209C6.12874 4.68519 6.18317 4.55378 6.18317 4.41675V3.26675H11.8165V4.41675C11.8165 4.55378 11.8709 4.68519 11.9678 4.78209C12.0647 4.87898 12.1961 4.93341 12.3332 4.93341C12.4702 4.93341 12.6016 4.87898 12.6985 4.78209C12.7954 4.68519 12.8498 4.55378 12.8498 4.41675V3.26675H15.2498C15.5548 3.26675 15.8473 3.38791 16.063 3.60357C16.2787 3.81924 16.3998 4.11175 16.3998 4.41675V7.23341Z" fill="#1E1E1E" stroke="#1E1E1E" stroke-width="0.2" />
                                            </svg>
                                        </div>
                                        {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}
                                    </div>
                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Deadline Date*</label>
                                    <div className="input-wrapper">
                                        <input
                                            type="date"
                                            id="deadline_date"
                                            value={formData.deadline_date}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                        />
                                        <div className="icon-wrapper">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.2498 2.23341H12.8498V1.08341C12.8498 0.946386 12.7954 0.81497 12.6985 0.718076C12.6016 0.621183 12.4702 0.566748 12.3332 0.566748C12.1961 0.566748 12.0647 0.621182 11.9678 0.718076C11.8709 0.81497 11.8165 0.946387 11.8165 1.08341V2.23341H6.18317V1.08341C6.18317 0.946387 6.12874 0.81497 6.03184 0.718076C5.93495 0.621182 5.80353 0.566748 5.6665 0.566748C5.52948 0.566748 5.39806 0.621182 5.30117 0.718076C5.20427 0.81497 5.14984 0.946386 5.14984 1.08341V2.23341H2.74984L2.74972 2.23341C2.17091 2.23411 1.616 2.46435 1.20672 2.87363C0.797436 3.28291 0.567197 3.83782 0.566504 4.41663V4.41675L0.566504 15.2501L0.566504 15.2502C0.567197 15.829 0.797436 16.3839 1.20672 16.7932C1.616 17.2025 2.17091 17.4327 2.74972 17.4334H2.74984H15.2498C15.8289 17.4334 16.3842 17.2034 16.7937 16.7939C17.2031 16.3845 17.4332 15.8291 17.4332 15.2501V4.41675C17.4332 3.83769 17.2031 3.28235 16.7937 2.8729C16.3842 2.46344 15.8289 2.23341 15.2498 2.23341ZM16.3998 15.2501C16.3998 15.5551 16.2787 15.8476 16.063 16.0633C15.8473 16.2789 15.5548 16.4001 15.2498 16.4001H2.74984C2.44484 16.4001 2.15233 16.2789 1.93666 16.0633C1.721 15.8476 1.59984 15.5551 1.59984 15.2501V8.26675H16.3998V15.2501ZM16.3998 7.23341H1.59984V4.41675C1.59984 3.78189 2.11349 3.26675 2.74984 3.26675H5.14984V4.41675C5.14984 4.55378 5.20427 4.68519 5.30117 4.78209C5.39806 4.87898 5.52948 4.93341 5.6665 4.93341C5.80353 4.93341 5.93495 4.87898 6.03184 4.78209C6.12874 4.68519 6.18317 4.55378 6.18317 4.41675V3.26675H11.8165V4.41675C11.8165 4.55378 11.8709 4.68519 11.9678 4.78209C12.0647 4.87898 12.1961 4.93341 12.3332 4.93341C12.4702 4.93341 12.6016 4.87898 12.6985 4.78209C12.7954 4.68519 12.8498 4.55378 12.8498 4.41675V3.26675H15.2498C15.5548 3.26675 15.8473 3.38791 16.063 3.60357C16.2787 3.81924 16.3998 4.11175 16.3998 4.41675V7.23341Z" fill="#1E1E1E" stroke="#1E1E1E" stroke-width="0.2" />
                                            </svg>
                                        </div>
                                        {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}
                                    </div>
                                </div>

                            </div>

                            <div
                                // className="flex-column full-width-form"
                                className={formData?.activity_type === "internal" ? "flex-column full-width-form" : "flex-column"}
                            >
                                <label className="form-labels"> Documentations : <span className="required">*</span></label>
                                <label className="form-input-doc full-width-form" htmlFor="uploaded_file" >
                                    {/* <DocImg /> */}
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">Select File</span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    onChange={handleInputChange}
                                    // className={`form-input  ${errors.length ? 'error' : inputState.length ? 'success' : ''}`}
                                    style={{ display: "none" }}
                                />
                                {errors.length && <span className="error-message">{errors.length}</span>}
                            </div>

                        </div>


                        <div className="button-models-add">
                            <button onClick={handleFormSubmit} className="model-button-add">Add</button>
                            <button
                                // onclick={handleClose} 
                                className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

const EditActivity = ({ i, projectID,
    department_name,
    getDepartmentList, weightage }) => {
    const [fileNames, setFileNames] = useState([]);
    console.log(i, 'i')
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        activity_name: '',
        activity_type: '',
        activity_description: '',
        project_detail: projectID ? projectID : "",
        department_name: department_name ? department_name : "",
        activity_parent: '',
        assigned_by: '',
        assigned_to: '',
        weightage: '',
        assign_date: '',
        deadline_date: '',
        uploaded_file: "",
        vendor_name: '',
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            'activity_name',
            'activity_type',
            'weightage',
            // "assign_date",
            // "deadline_date",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)



    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = allActivity.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > weightage) {
                console.log("100")
                newErrors.weightage = `Total weightage cannot be exceeds  ${weightage} (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };





    const handleShow = () => {
        setShow(true);
        setFormData(i)

    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }


    const [allEmployeeData, setAllEmployeeData] = useState([]);


    const [allActivity, setAllActivity] = useState([]);

    const fetchActivity = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/project-details/activitytype/`);
            setAllActivity(res.data);
        } catch (err) {

        }
    };

    useEffect(() => {

        getEmployeeDetails();
        fetchActivity()
    }, []);



    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const assigned_to = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            assigned_to,
        }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const newerror = {};

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const formDataToSend = new FormData();


                Object.keys(formData).forEach((key) => {
                    if (formData[key] && key !== "uploaded_file") {
                        formDataToSend.append(key, formData[key]);
                    }
                });




                const symbols = "!@#$%^&*()_-+=";
                const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const numbers = "0123456789";
                const now = new Date();
                const date = now
                    .toLocaleDateString("en-GB")
                    .split("/")
                    .reverse()
                    .join("-");
                const time = now
                    .toLocaleTimeString("en-GB", { hour12: false })
                    .replace(/:/g, "-");
                const allChars =
                    symbols + lowercaseLetters + uppercaseLetters + numbers;
                let randomCode = "";
                for (let i = 0; i < 8; i++) {
                    const randomIndex = Math.floor(Math.random() * allChars.length);
                    randomCode += allChars[randomIndex];
                }

                const originalFile2 = formData.uploaded_file;
                const customFileName2 = `Aimantra ${date} ${time}_${randomCode} ${originalFile2.name}`;
                const customFile2 = new File([originalFile2], customFileName2, {
                    type: originalFile2.type,
                });





                formDataToSend.append("uploaded_file", customFile2);


                let res = await axios.put(
                    `${BASE_URL}/project-details/activitytype/${i.id}/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button
                title="Add Detail Design"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Edit Activity
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Edit Activity</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_name"
                                    value={formData?.activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.activity_name ? 'error' : inputState.activity_name ? 'success' : ''}`}
                                />
                                {errors.activity_name && <span className="error-message">{errors.activity_name}</span>}
                            </div>
                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Type <span className="required">*</span></label>
                                <select
                                    id="activity_type"
                                    name="activity_type"
                                    value={formData.activity_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.activity_type
                                        ? "error"
                                        : inputState.activity_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Activity Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.activity_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.activity_type}
                                        </span>
                                    )}
                                </div>


                            </div>


                            <div className="flex-column">
                                <label className="form-labels">Activity Discription <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter the Activity Name"
                                    name="activity_description"
                                    value={formData.activity_description}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input  ${errors.activity_description ? 'error' : inputState.activity_description ? 'success' : ''}`}
                                />
                                {errors.activity_description && <span className="error-message">{errors.activity_description}</span>}
                            </div>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Activity Parent <span className="required">*</span></label>



                                {allActivity.length === 0 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                    </div>
                                ) : (
                                    <>
                                        <select
                                            id="activity_parent"
                                            name="activity_parent"
                                            value={formData.activity_parent}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.activity_parent
                                                ? "error"
                                                : inputState.activity_parent
                                                    ? "success"
                                                    : ""
                                                }`}
                                        >
                                            <option value="">Select a Activity</option>

                                        </select>
                                        <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors.department && (
                                                <span className="error-message font-size-text ">
                                                    {errors.department}
                                                </span>
                                            )}
                                        </div>
                                    </>
                                )}

                            </div>

                            {formData?.activity_type === "internal" ?
                                (
                                    <>
                                        <div title="assigned_by" className="flex-column form-group-selectt">
                                            <label htmlFor="assigned_by" className="form-labels font-weight500 font-size-subheading">
                                                Team Lead<span className="required">*</span>
                                            </label>

                                            {allEmployeeData.length === 0 ?
                                                <div className="form-loader">
                                                    <div className="bar-loader"></div>
                                                </div> :
                                                <>
                                                    <select
                                                        id="assigned_by"
                                                        name="assigned_by"
                                                        value={formData.assigned_by} // Changed from `project` to `team_lead`
                                                        onChange={handleInputChange}
                                                        className={`form-input form-group-selection ${errors.assigned_by ? "error" : inputState.assigned_by ? "success" : ""}`}

                                                    >
                                                        <option value="">Select Team Lead</option>
                                                        {allEmployeeData?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                                            <option key={index} value={i.emp_code}>
                                                                {`${i.emp_code} - ${i.name}`} {/* Adjusted to show the structure name */}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                        </svg>
                                                    </div>
                                                    <div>
                                                        {errors.assigned_by && (
                                                            <span className="error-message font-size-text ">{errors.assigned_by}</span>
                                                        )}
                                                    </div>
                                                </>}
                                        </div>
                                        <div className="flex-column form-group-select">
                                            <label className="form-labels">
                                                Assigned To:<span className="required">*</span>
                                            </label>

                                            <Select
                                                options={options}
                                                isMulti
                                                onChange={selectEmployee}
                                                value={formData.assignedto?.map((code) => ({
                                                    value: code,
                                                    label: options.find((opt) => opt.value === code)?.label || code,
                                                }))}
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        minHeight: '50px',
                                                        borderRadius: '10px',
                                                        border: '1px solid #e3e3e3',
                                                        margin: '10px 0px 20px 0px',
                                                        color: '#4a4a4a',
                                                        backgroundColor: '#f4f7fe',
                                                        padding: '0px 10px',
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        borderRadius: '10px',
                                                        marginTop: '0',
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: '#4a4a4a',
                                                    }),
                                                }}
                                            />

                                            {errors.employee && (
                                                <span className="error-message font-size-text ">{errors.employee}</span>
                                            )}
                                        </div>
                                    </>)
                                : (<>
                                    <div className="flex-column">
                                        <label className="form-labels">Vendor Name<span className="required">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Enter the Vendor Name"
                                            name="vendor_name"
                                            value={formData.vendor_name}
                                            onChange={handleInputChange}
                                            className={`activity-form form-input  ${errors.vendor_name ? 'error' : inputState.vendor_name ? 'success' : ''}`}
                                        />
                                        {errors.vendor_name && <span className="error-message">{errors.vendor_name}</span>}
                                    </div>
                                </>)}
                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.weightage ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>

                            <div className="date-box">
                                <div className="date-filed-half">
                                    <label htmlFor="assign_date" className="form-labels">Start Date*</label>
                                    <div className="input-wrapper">
                                        <input
                                            type="date"
                                            id="assign_date"
                                            value={formData.assign_date}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.assign_date ? 'error' : inputState.assign_date ? 'success' : ''}`}
                                        />
                                        <div className="icon-wrapper">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.2498 2.23341H12.8498V1.08341C12.8498 0.946386 12.7954 0.81497 12.6985 0.718076C12.6016 0.621183 12.4702 0.566748 12.3332 0.566748C12.1961 0.566748 12.0647 0.621182 11.9678 0.718076C11.8709 0.81497 11.8165 0.946387 11.8165 1.08341V2.23341H6.18317V1.08341C6.18317 0.946387 6.12874 0.81497 6.03184 0.718076C5.93495 0.621182 5.80353 0.566748 5.6665 0.566748C5.52948 0.566748 5.39806 0.621182 5.30117 0.718076C5.20427 0.81497 5.14984 0.946386 5.14984 1.08341V2.23341H2.74984L2.74972 2.23341C2.17091 2.23411 1.616 2.46435 1.20672 2.87363C0.797436 3.28291 0.567197 3.83782 0.566504 4.41663V4.41675L0.566504 15.2501L0.566504 15.2502C0.567197 15.829 0.797436 16.3839 1.20672 16.7932C1.616 17.2025 2.17091 17.4327 2.74972 17.4334H2.74984H15.2498C15.8289 17.4334 16.3842 17.2034 16.7937 16.7939C17.2031 16.3845 17.4332 15.8291 17.4332 15.2501V4.41675C17.4332 3.83769 17.2031 3.28235 16.7937 2.8729C16.3842 2.46344 15.8289 2.23341 15.2498 2.23341ZM16.3998 15.2501C16.3998 15.5551 16.2787 15.8476 16.063 16.0633C15.8473 16.2789 15.5548 16.4001 15.2498 16.4001H2.74984C2.44484 16.4001 2.15233 16.2789 1.93666 16.0633C1.721 15.8476 1.59984 15.5551 1.59984 15.2501V8.26675H16.3998V15.2501ZM16.3998 7.23341H1.59984V4.41675C1.59984 3.78189 2.11349 3.26675 2.74984 3.26675H5.14984V4.41675C5.14984 4.55378 5.20427 4.68519 5.30117 4.78209C5.39806 4.87898 5.52948 4.93341 5.6665 4.93341C5.80353 4.93341 5.93495 4.87898 6.03184 4.78209C6.12874 4.68519 6.18317 4.55378 6.18317 4.41675V3.26675H11.8165V4.41675C11.8165 4.55378 11.8709 4.68519 11.9678 4.78209C12.0647 4.87898 12.1961 4.93341 12.3332 4.93341C12.4702 4.93341 12.6016 4.87898 12.6985 4.78209C12.7954 4.68519 12.8498 4.55378 12.8498 4.41675V3.26675H15.2498C15.5548 3.26675 15.8473 3.38791 16.063 3.60357C16.2787 3.81924 16.3998 4.11175 16.3998 4.41675V7.23341Z" fill="#1E1E1E" stroke="#1E1E1E" stroke-width="0.2" />
                                            </svg>
                                        </div>
                                        {errors.assign_date && <span className="error-message">{errors.assign_date}</span>}
                                    </div>
                                </div>
                                <div className="date-filed-half">

                                    <label htmlFor="deadline_date" className="form-labels">Deadline Date*</label>
                                    <div className="input-wrapper">
                                        <input
                                            type="date"
                                            id="deadline_date"
                                            value={formData.deadline_date}
                                            onChange={handleInputChange}
                                            className={`form-input  ${errors.deadline_date ? 'error' : inputState.deadline_date ? 'success' : ''}`}
                                        />
                                        {/* <div className="icon-wrapper">
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M15.2498 2.23341H12.8498V1.08341C12.8498 0.946386 12.7954 0.81497 12.6985 0.718076C12.6016 0.621183 12.4702 0.566748 12.3332 0.566748C12.1961 0.566748 12.0647 0.621182 11.9678 0.718076C11.8709 0.81497 11.8165 0.946387 11.8165 1.08341V2.23341H6.18317V1.08341C6.18317 0.946387 6.12874 0.81497 6.03184 0.718076C5.93495 0.621182 5.80353 0.566748 5.6665 0.566748C5.52948 0.566748 5.39806 0.621182 5.30117 0.718076C5.20427 0.81497 5.14984 0.946386 5.14984 1.08341V2.23341H2.74984L2.74972 2.23341C2.17091 2.23411 1.616 2.46435 1.20672 2.87363C0.797436 3.28291 0.567197 3.83782 0.566504 4.41663V4.41675L0.566504 15.2501L0.566504 15.2502C0.567197 15.829 0.797436 16.3839 1.20672 16.7932C1.616 17.2025 2.17091 17.4327 2.74972 17.4334H2.74984H15.2498C15.8289 17.4334 16.3842 17.2034 16.7937 16.7939C17.2031 16.3845 17.4332 15.8291 17.4332 15.2501V4.41675C17.4332 3.83769 17.2031 3.28235 16.7937 2.8729C16.3842 2.46344 15.8289 2.23341 15.2498 2.23341ZM16.3998 15.2501C16.3998 15.5551 16.2787 15.8476 16.063 16.0633C15.8473 16.2789 15.5548 16.4001 15.2498 16.4001H2.74984C2.44484 16.4001 2.15233 16.2789 1.93666 16.0633C1.721 15.8476 1.59984 15.5551 1.59984 15.2501V8.26675H16.3998V15.2501ZM16.3998 7.23341H1.59984V4.41675C1.59984 3.78189 2.11349 3.26675 2.74984 3.26675H5.14984V4.41675C5.14984 4.55378 5.20427 4.68519 5.30117 4.78209C5.39806 4.87898 5.52948 4.93341 5.6665 4.93341C5.80353 4.93341 5.93495 4.87898 6.03184 4.78209C6.12874 4.68519 6.18317 4.55378 6.18317 4.41675V3.26675H11.8165V4.41675C11.8165 4.55378 11.8709 4.68519 11.9678 4.78209C12.0647 4.87898 12.1961 4.93341 12.3332 4.93341C12.4702 4.93341 12.6016 4.87898 12.6985 4.78209C12.7954 4.68519 12.8498 4.55378 12.8498 4.41675V3.26675H15.2498C15.5548 3.26675 15.8473 3.38791 16.063 3.60357C16.2787 3.81924 16.3998 4.11175 16.3998 4.41675V7.23341Z" fill="#1E1E1E" stroke="#1E1E1E" stroke-width="0.2" />
                                            </svg>
                                        </div> */}
                                        {errors.deadline_date && <span className="error-message">{errors.deadline_date}</span>}
                                    </div>
                                </div>

                            </div>

                            <div
                                // className="flex-column full-width-form"
                                className={formData?.activity_type === "internal" ? "flex-column full-width-form" : "flex-column"}
                            >
                                <label className="form-labels"> Documentations : <span className="required">*</span></label>
                                <label className="form-input-doc full-width-form" htmlFor="uploaded_file" >
                                    {/* <DocImg /> */}
                                    <span className="file-label-selectFile" htmlFor="uploaded_file">Select File</span>
                                </label>

                                <input
                                    type="file"
                                    name="uploaded_file"
                                    id="uploaded_file"
                                    accept=".pdf,.doc,.docx,.jpg,.png"
                                    onChange={handleInputChange}
                                    // className={`form-input  ${errors.length ? 'error' : inputState.length ? 'success' : ''}`}
                                    style={{ display: "none" }}
                                />
                                {errors.length && <span className="error-message">{errors.length}</span>}
                            </div>

                        </div>


                        <div className="button-models-add">
                            <button onClick={handleFormSubmit} className="model-button-add">Add</button>
                            <button
                                // onclick={handleClose} 
                                className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}


const AddEditProjectDepartment = ({ projectID, departmentlist, allDepartmentlist, getDepartmentList }) => {
    const [fileNames, setFileNames] = useState([]);
    const [show, setShow] = useState(false);

    const handleShow = () => {
        if (departmentlist && departmentlist.length > 0) {
            setDepartments(departmentlist.map(id => ({ department_id: id })));
        } else {
            setDepartments([{ department_id: '' }]);
        }
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [loading, setLoading] = useState(false);

    const [departments, setDepartments] = useState([{ department_id: '' }]);

    const validateForm = () => {
        const newErrors = {};

        departments.forEach((dept, index) => {
            if (!dept.department_id) {
                newErrors[`department_${index}`] = `Department is required for row ${index + 1}`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    const handleAddDepartment = () => {
        setDepartments([
            ...departments,
            { department_id: '' },
        ]);
    };

    const handleRemoveDepartment = (index) => {
        const updatedFields = [...departments];
        updatedFields.splice(index, 1);
        setDepartments(updatedFields);
    };

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const newDepartmentFields = [...departments];
        newDepartmentFields[index][name] = value;
        setDepartments(newDepartmentFields);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const departmentIds = departments.map(dept => dept.department_id);

                let res = await axios.put(
                    `${BASE_URL}/project_details/project/${projectID}/`,
                    { departments: departmentIds }
                );

                if (res.status === 200) {
                    setShow(false);
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                    toast.success("Departments updated successfully");
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                title="Add Department to Project"
                className="upload-svg"
                onClick={handleShow}
            >
                <UpdatePencilWhite /> Departments of Project
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="half-modal"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title>
                        <h4 className="heading-name">Add Department To Project</h4>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="add-activity">
                        <div className="form-column">

                            {departments.map((dept, index) => (
                                <div key={index} className="flex-row justify-between align-center">
                                    <div className=" form-group-selectt">
                                        <select
                                            id={`department-${index}`}
                                            name="department_id"
                                            value={dept.department_id}
                                            onChange={(e) => handleInputChange(index, e)}
                                            className={`form-input form-group-selection ${errors[`department_${index}`]
                                                ? "error"
                                                : inputState.department
                                                    ? "success"
                                                    : ""
                                                }`}
                                        >
                                            <option value="">Select a Department</option>
                                            {allDepartmentlist
                                                ?.sort((a, b) =>
                                                    a?.name?.localeCompare(b.name, "en", {
                                                        ignorePunctuation: true,
                                                    })
                                                )
                                                .map((item) => (
                                                    <option key={item.id} value={item.id}>
                                                        {`${item.name || item.title}`}
                                                    </option>
                                                ))}
                                        </select>
                                        <DropdownArrow />
                                    </div>
                                    <div>
                                        {errors[`department_${index}`] && (
                                            <span className="error-message font-size-text">
                                                {errors[`department_${index}`]}
                                            </span>
                                        )}
                                    </div>
                                    {index > 0 && <button
                                        className="remove-btn"
                                        type="button"
                                        onClick={() => handleRemoveDepartment(index)}
                                        title="Remove"
                                    >
                                        <CrosswithGreyCircle />
                                    </button>}
                                </div>
                            ))}
                        </div>

                        <div className="flex-row ">
                            <button
                                type="button"
                                title="Add Department"
                                className="upload-svg"
                                onClick={handleAddDepartment}
                            >
                                <AddwithWhiteCircle /> Department
                            </button>
                        </div>
                        <div className="button-models-add" style={{ gap: "20px" }}>
                            <button
                                type="button"
                                className="model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                onClick={handleSubmit}
                                className="model-button model-button-submit"
                                disabled={loading}
                            >
                                {loading ? 'Updating...' : 'Update'}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

const DepartmentProjectDelete = ({ i, projectID, getDepartmentList }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/project-details/highwaydepartment/${i.id}/`
            );

            if (res.status === 200 || res.status === 201) {
                await getDepartmentList();
                setShow(false);
            } else {
                console.error('Error in handleFormSubmitDelete')
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Insurance"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Departrtment {i.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Department "{i.name}"" from Project
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};

const AddDepartment = ({ projectID, getDepartmentList, departmentlist }) => {
    const [fileNames, setFileNames] = useState([]);

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        department: '',
        team_lead: [],
        employee: [],
        project: projectID ? projectID : "",
        department_type: 'internal',
        division_name: '',
        weightage: "",
        division_head_name: [],

        // name: "",
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [

            'department_type',
            // 'client',
            // "sub_Company",
            // "concern_person",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {



                let res = await axios.post(
                    `${BASE_URL}/project-details/highwaydepartment/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "Application/json",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };



    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = departmentlist?.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > 100) {
                console.log("100")
                newErrors.weightage = `Total weightage exceeds 100% (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };





    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }

    const [project, setProject] = useState([]);
    const [allEmployeeData, setAllEmployeeData] = useState([]);
    const getAllproject = async () => {
        try {
            const sub = await axios.get(
                `${BASE_URL}/project_details/project-filter/null/null/`
            );
            setProject(sub.data);
        } catch (err) {
        } finally {
        }
    };

    const [allDepartments, setAllDepartments] = useState([]);

    const fetchDepartments = async () => {

        try {
            const res = await axios.get(`${BASE_URL}/configuration/department/`);
            setAllDepartments(res.data);
        } catch (err) {
            toast.error("Failed to fetch departments.");
        }
    };

    useEffect(() => {
        if (show) {
            setFormData((prevState) => ({
                ...prevState,
                department_type: 'internal',
            }));
            getAllproject();
            getEmployeeDetails();
            fetchDepartments()
        }

    }, [show]);

    const selectTeamlead = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const team_lead = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            team_lead,
        }));
    };

    const selectheadDivision = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const division_head_name = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            division_head_name,
        }));
    };

    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id") || 'null');
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/manpower/employee/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const employee = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            employee,
        }));
    };

    // add Vender??/////////////////////////////////////////////////////////////

    const [formdata2, setFormData2] = useState({
        name: "",
        sub_Company: "",
        contact_person: "",
        address: "",
        email: "",
        contact_number: "",
        alt_contact_number: "",
        gstin_number: "",
        pos: ""
    })

    const validateform2 = () => {
        const newErrors = {};
        const requiredFields = [
            "sub_Company",
            "pos",
            "name",
            "gstin_number",

        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });





        setErrors(newErrors);
        // setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };
    const [sub_CompanyList, setsub_CompanyList] = useState([]);
    const [showForm, setShowForm] = useState(false);

    const handleAddVendor = () => {
        setShowForm(!showForm);
    };
    const handleSubmitVendor = async (e) => {
        e.preventDefault();

        if (validateform2()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const formDataToSend = new FormData();


                Object.keys(formdata2).forEach((key) => {

                    formDataToSend.append(key, formData[key]);

                });







                let res = await axios.post(
                    `${BASE_URL}/project-details/vendor/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShowForm(false);
                    setFormData2(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFormData((prevData) => ({
                        ...prevData,
                        vendor_name: res.data.id
                    }));
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);

                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    const getAllsub_Company = async () => {

        try {
            const sub = await axios.get(`${BASE_URL}/configuration/subcompany/`);
            setsub_CompanyList(sub.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {

        }
    };
    useEffect(() => {

        getAllsub_Company();

    }, [])


    // console.log(formData, "formData");




    return (
        <>
            <button
                title="Add Department to Project"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Add Department to Project
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Add Department To Project</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='division-type'>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Division Type <span className="required">*</span></label>
                                <select
                                    id="department_type"
                                    name="department_type"
                                    value={formData.department_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.department_type
                                        ? "error"
                                        : inputState.department_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Department Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.department_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.department_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input weight-input  ${errors.location ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                {/* <span className="model-button-placeholder"> %age*</span> */}
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>
                        </div>
                        {formData?.department_type === "internal" ? (
                            <>

                                <div className='division-type'>
                                    <div className="flex-column">
                                        <label className="form-labels">Name Of Division<span className="required">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Name of Division"
                                            name="division_name"
                                            value={formData.division_name}
                                            onChange={handleInputChange}
                                            className={`activity-form form-input weight-input ${errors.division_name ? 'error' : inputState.division_name ? 'success' : ''}`}
                                        />
                                        {errors.division_name && <span className="error-message">{errors.division_name}</span>}
                                    </div>


                                    <div className="flex-column form-group-selectt">
                                        <label className="form-labels">Department <span className="required">*</span></label>



                                        {allDepartments.length === 0 ? (
                                            <div className="form-loader">
                                                <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                            </div>
                                        ) : (
                                            <>
                                                <select
                                                    id="department"
                                                    name="department"
                                                    value={formData.department}
                                                    onChange={handleInputChange}
                                                    className={`form-input form-group-selection ${errors.department
                                                        ? "error"
                                                        : inputState.department
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                >
                                                    <option value="">Select a Department</option>
                                                    {allDepartments
                                                        ?.sort((a, b) =>
                                                            a?.name?.localeCompare(b.project_name, "en", {
                                                                ignorePunctuation: true,
                                                            })
                                                        )
                                                        .map((i, index) => (
                                                            <>

                                                                <option value={i.id}>{`${i?.department ? `${i.id}-` : ""}${i.title}`}</option>
                                                            </>
                                                        ))}
                                                </select>
                                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    {errors.department && (
                                                        <span className="error-message font-size-text ">
                                                            {errors.department}
                                                        </span>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                    </div>
                                </div>

                                <div className='division-type'>
                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Head Of Division:<span className="required">*</span>
                                        </label>

                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectheadDivision}
                                            value={formData.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.division_head_name && (
                                            <span className="error-message font-size-text ">{errors.division_head_name}</span>
                                        )}
                                    </div>

                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Team Lead:<span className="required">*</span>
                                        </label>

                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectTeamlead}
                                            value={formData.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.team_lead && (
                                            <span className="error-message font-size-text ">{errors.team_lead}</span>
                                        )}
                                    </div>
                                </div>


                                <div className="flex-column form-group-select">
                                    <label className="form-labels">
                                        Employee:<span className="required">*</span>
                                    </label>

                                    <Select
                                        options={options}
                                        isMulti
                                        onChange={selectEmployee}
                                        value={formData.assignedto?.map((code) => ({
                                            value: code,
                                            label: options.find((opt) => opt.value === code)?.label || code,
                                        }))}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                                minHeight: '50px',
                                                borderRadius: '10px',
                                                border: '1px solid #e3e3e3',
                                                margin: '10px 0px 20px 0px',
                                                color: '#4a4a4a',
                                                backgroundColor: '#f4f7fe',
                                                padding: '0px 10px',
                                            }),
                                            placeholder: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                borderRadius: '10px',
                                                marginTop: '0',
                                            }),
                                            input: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                            singleValue: (provided) => ({
                                                ...provided,
                                                color: '#4a4a4a',
                                            }),
                                        }}
                                    />

                                    {errors.employee && (
                                        <span className="error-message font-size-text ">{errors.employee}</span>
                                    )}
                                </div>
                            </>
                        ) : (<>




                        </>)}












                        <div className="button-models-add" style={{ gap: "20px" }}>
                            <button
                                // onclick={handleSubmit}
                                className="model-button-cancel">Cancel</button>
                            <button onClick={handleSubmit} className="model-button model-button-submit">Add</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}
const EditDepartment = ({ i, projectID, getDepartmentList, departmentlist }) => {
    const [fileNames, setFileNames] = useState([]);

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState({
        department: '',
        team_lead: '',
        employee: '',
        project: projectID ? projectID : "",
        department_type: 'internal',
        division_name: '',
        weightage: "",
        division_head_name: "",

        // name: "",
    });




    const [errors, setErrors] = useState({});

    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [

            'department_type',
            // 'client',
            // "sub_Company",
            // "concern_person",
        ];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
            }
        });

        setErrors(newErrors);


        return Object.keys(newErrors).length === 0;
    };

    console.log(formData)

    console.log(errors)

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                // const formDataToSend = new FormData();


                // Object.keys(formData).forEach((key) => {

                //     formDataToSend.append(key, formData[key]);

                // });


                // console.log({ formDataToSend })


                let res = await axios.put(
                    `${BASE_URL}/project_details/highwaydepartment/${i.id}/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "Application/json",
                        },
                    }
                );

                if (res.status === 200) {
                    setShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getDepartmentList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };



    const handleInputChange = (e) => {
        const { name, value, type, checked, options, files } = e.target;
        console.log(files);
        let newValue;
        if (type === "select-multiple") {
            newValue = Array.from(options)
                .filter((option) => option.selected)
                .map((option) => option.value);
        } else if (type === "checkbox") {
            newValue = checked;
        } else if (type === "file") {
            newValue = files.length > 0 ? files[0] : null;
        } else {
            newValue = value;
        }
        if (name === "weightage") {
            const newErrors = {};
            const inputWeight = parseFloat(value);
            const totalActivityWeight = departmentlist.reduce((sum, activity) => {
                const w = parseFloat(activity.weightage);
                return sum + (isNaN(w) ? 0 : w);
            }, 0);

            const totalWeight = totalActivityWeight + (isNaN(inputWeight) ? 0 : inputWeight);

            if (totalWeight > 100) {
                console.log("100")
                newErrors.weightage = `Total weightage exceeds 100% (Current total: ${totalWeight}%)`;
                console.log(newErrors)
                setErrors(newErrors);
            } else {
                setErrors((prevErrors) => {
                    const updatedErrors = { ...prevErrors };
                    delete updatedErrors[name];
                    return updatedErrors;
                });
            }
        }
        console.log(errors, 'errors');
        setInputState((prevState) => ({
            ...prevState,
            [name]:
                type === "checkbox"
                    ? checked
                        ? "green"
                        : ""
                    : newValue
                        ? "green"
                        : "",
        }));


        // setErrors((prevErrors) => {
        //     const { [name]: removedError, ...rest } = prevErrors;
        //     return rest;
        // });


        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: newValue,
            };

            return updatedFormData;
        });

        if (value.trim() && name !== "weightage") {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };






    const handleShow = () => {
        console.log(i, "i")
        setFormData(i)
        setShow(true);

    }

    const handleClose = () => {
        setShow(false);
        setFormData(() =>
            Object.keys(formData).reduce((acc, key) => {
                acc[key] = "";
                return acc;
            }, {})
        );
    }

    const [project, setProject] = useState([]);
    const [allEmployeeData, setAllEmployeeData] = useState([]);
    const getAllproject = async () => {
        try {
            const sub = await axios.get(
                `${BASE_URL}/project_details/project-filter/null/null/`
            );
            setProject(sub.data);
        } catch (err) {
        } finally {
        }
    };

    const [allDepartments, setAllDepartments] = useState([]);

    const fetchDepartments = async () => {
        const id = '025d0b52-e892-4868-a3bb-6b70dcdffb4d';
        try {
            const res = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${id}/active/`);
            setAllDepartments(res.data);
        } catch (err) {
            toast.error("Failed to fetch departments.");
        }
    };

    useEffect(() => {
        if (show) {
            setFormData((prevState) => ({
                ...prevState,
                department_type: 'internal',
            }));
            getAllproject();
            getEmployeeDetails();
            fetchDepartments()
        }

    }, [show]);

    const selectTeamlead = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const team_lead = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            team_lead,
        }));
    };

    const selectheadDivision = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const division_head_name = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            division_head_name,
        }));
    };

    const options = allEmployeeData
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => ({
            value: e.emp_code,
            label: `${e.emp_code} - ${e.name}`,
        }));
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
            );

            setAllEmployeeData(res.data);
        } catch (err) {
            // handleErrorToast(err);
        }
    };

    const selectEmployee = (selected) => {
        // const assignedto = selected.length > 0 ? selected?.map((item) => item.value) : "";
        const employee = selected?.map((item) => item.value) || [];
        setFormData((prevState) => ({
            ...prevState,
            employee,
        }));
    };

    // add Vender??/////////////////////////////////////////////////////////////

    const [formdata2, setFormData2] = useState({
        name: "",
        sub_Company: "",
        contact_person: "",
        address: "",
        email: "",
        contact_number: "",
        alt_contact_number: "",
        gstin_number: "",
        pos: ""
    })

    const validateform2 = () => {
        const newErrors = {};
        const requiredFields = [
            "sub_Company",
            "pos",
            "name",
            "gstin_number",

        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });





        setErrors(newErrors);
        // setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };
    const [sub_CompanyList, setsub_CompanyList] = useState([]);
    const [showForm, setShowForm] = useState(false);

    const handleAddVendor = () => {
        setShowForm(!showForm);
    };
    const handleSubmitVendor = async (e) => {
        e.preventDefault();

        if (validateform2()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {
                const formDataToSend = new FormData();


                Object.keys(formdata2).forEach((key) => {

                    formDataToSend.append(key, formData[key]);

                });







                let res = await axios.put(
                    `${BASE_URL}/project-details/highwaydepartment/${i.id}/`,
                    formDataToSend,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    setShowForm(false);
                    setFormData2(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );
                    setFileNames(() => {
                        return new Array(fileNames.length).fill("");
                    });
                    setErrors({});
                    setLoading(false);
                    await getAllVendor();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    const getAllsub_Company = async () => {

        try {
            const sub = await axios.get(`${BASE_URL}/project-details/subCompany/`);
            setsub_CompanyList(sub.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {

        }
    };
    useEffect(() => {
        getAllVendor();
        getAllsub_Company();

    }, [])
    const [vendorList, SetVendorList] = useState([]);
    const getAllVendor = async () => {

        try {
            const sub = await axios.get(`${BASE_URL}/project-details/highwaydepartment/`);
            SetVendorList(sub.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {

        }
    };

    console.log({ allDepartments });




    return (
        <>
            <button
                title="Edit Division"
                className="upload-svg"
                onClick={handleShow}
            >
                <svg xmlns="http://www.w3.org/2000/svg"
                    width="20" height="20" enable-background="new 0 0 32 32" viewBox="0 0 32 32" fill='white'
                    id="edit">
                    <path d="M3.5,24h15A3.51,3.51,0,0,0,22,20.487V12.95a1,1,0,0,0-2,0v7.537A1.508,1.508,0,0,1,18.5,22H3.5A1.508,1.508,0,0,1,2,20.487V5.513A1.508,1.508,0,0,1,3.5,4H11a1,1,0,0,0,0-2H3.5A3.51,3.51,0,0,0,0,5.513V20.487A3.51,3.51,0,0,0,3.5,24Z"></path><path d="M9.455,10.544l-.789,3.614a1,1,0,0,0,.271.921,1.038,1.038,0,0,0,.92.269l3.606-.791a1,1,0,0,0,.494-.271l9.114-9.114a3,3,0,0,0,0-4.243,3.07,3.07,0,0,0-4.242,0l-9.1,9.123A1,1,0,0,0,9.455,10.544Zm10.788-8.2a1.022,1.022,0,0,1,1.414,0,1.009,1.009,0,0,1,0,1.413l-.707.707L19.536,3.05Zm-8.9,8.914,6.774-6.791,1.4,1.407-6.777,6.793-1.795.394Z"></path></svg> Edit Division
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="Activity-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500 font-size-heading"
                >
                    <Modal.Title><h4 className="heading-name">Edit Division</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form className="add-activity">
                        <div className='form-flex-wrap'>

                            <div className="flex-column form-group-selectt">
                                <label className="form-labels">Division Type <span className="required">*</span></label>
                                <select
                                    id="department_type"
                                    name="department_type"
                                    value={formData?.department_type}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.department_type
                                        ? "error"
                                        : inputState.department_type
                                            ? "success"
                                            : ""
                                        }`}
                                >
                                    <option value="">Select Department Type</option>
                                    <option value="internal">Internal</option>
                                    <option value="external">External</option>
                                </select>
                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                    </svg>
                                </div>
                                <div>
                                    {errors.department_type && (
                                        <span className="error-message font-size-text ">
                                            {errors.department_type}
                                        </span>
                                    )}
                                </div>


                            </div>

                            <div className="model-flex-column">
                                <label className="form-labels">Weightage %age* : <span className="required">*</span></label>

                                <input
                                    type="text"
                                    placeholder="Add Weightage of Task"
                                    name="weightage"
                                    value={formData?.weightage}
                                    onChange={handleInputChange}
                                    className={`form-input  ${errors.location ? 'error' : inputState.weightage ? 'success' : ''}`}
                                />
                                <span className="model-button-placeholder"> %age*</span>
                                {errors.weightage && <span className="error-message">{errors.weightage}</span>}
                            </div>
                            {formData?.department_type === "internal" ? (
                                <>
                                    <div className="flex-column">
                                        <label className="form-labels">Name Of Division<span className="required">*</span></label>
                                        <input
                                            type="text"
                                            placeholder="Name of Division"
                                            name="division_name"
                                            value={formData?.division_name}
                                            onChange={handleInputChange}
                                            className={`activity-form form-input  ${errors.division_name ? 'error' : inputState.division_name ? 'success' : ''}`}
                                        />
                                        {errors.division_name && <span className="error-message">{errors.division_name}</span>}
                                    </div>


                                    <div className="flex-column form-group-selectt">
                                        <label className="form-labels">Department <span className="required">*</span></label>



                                        {allDepartments.length === 0 ? (
                                            <div className="form-loader">
                                                <div className="bar-loader" style={{ width: '46.5%' }}></div>
                                            </div>
                                        ) : (
                                            <>
                                                <select
                                                    id="department"
                                                    name="department"
                                                    value={formData?.department}
                                                    onChange={handleInputChange}
                                                    className={`form-input form-group-selection ${errors.department
                                                        ? "error"
                                                        : inputState.department
                                                            ? "success"
                                                            : ""
                                                        }`}
                                                >
                                                    <option value="">Select a Department</option>
                                                    {allDepartments
                                                        ?.sort((a, b) =>
                                                            a?.name?.localeCompare(b.project_name, "en", {
                                                                ignorePunctuation: true,
                                                            })
                                                        )
                                                        .map((i, index) => (
                                                            <>

                                                                <option value={i.id}>{`${i?.department ? `${i.id}-` : ""}${i.title}`}</option>
                                                            </>
                                                        ))}
                                                </select>
                                                <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                    <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    {errors.department && (
                                                        <span className="error-message font-size-text ">
                                                            {errors.department}
                                                        </span>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                    </div>
                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Head Of Division:<span className="required">*</span>
                                        </label>

                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectheadDivision}
                                            value={formData?.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.division_head_name && (
                                            <span className="error-message font-size-text ">{errors?.division_head_name}</span>
                                        )}
                                    </div>

                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Team Lead:<span className="required">*</span>
                                        </label>

                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectTeamlead}
                                            value={formData?.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.team_lead && (
                                            <span className="error-message font-size-text ">{errors.team_lead}</span>
                                        )}
                                    </div>
                                    <div className="flex-column form-group-select">
                                        <label className="form-labels">
                                            Employee:<span className="required">*</span>
                                        </label>

                                        <Select
                                            options={options}
                                            isMulti
                                            onChange={selectEmployee}
                                            value={formData.assignedto?.map((code) => ({
                                                value: code,
                                                label: options.find((opt) => opt.value === code)?.label || code,
                                            }))}
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: '100%',
                                                    minHeight: '50px',
                                                    borderRadius: '10px',
                                                    border: '1px solid #e3e3e3',
                                                    margin: '10px 0px 20px 0px',
                                                    color: '#4a4a4a',
                                                    backgroundColor: '#f4f7fe',
                                                    padding: '0px 10px',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    borderRadius: '10px',
                                                    marginTop: '0',
                                                }),
                                                input: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#4a4a4a',
                                                }),
                                            }}
                                        />

                                        {errors.employee && (
                                            <span className="error-message font-size-text ">{errors.employee}</span>
                                        )}
                                    </div>
                                </>
                            ) : (<>

                                {/* *********************************************** External vender *********************************** */}
                                {!showForm && (
                                    <div title="Vendor Name" className="flex-column form-group-selectt">
                                        <label htmlFor="department_name" className="form-labels  font-weight500    font-size-subheading">
                                            Select Existing Vendor <span className="required">*</span>
                                        </label>

                                        <select
                                            id="department_name"
                                            name="department_name"
                                            value={formData?.department_name}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.department_name ? "error" : inputState.department_name ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select a Vendor</option>
                                            {vendorList?.sort((a, b) => a?.title?.localeCompare(b.company_name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                {console.log(i)}
                                                <option value={i.id}>{i?.title}</option>
                                            </>))
                                            }
                                        </select>
                                        <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors?.department_name && (
                                                <span className="error-message font-size-text ">{errors.department_name}</span>
                                            )}
                                        </div>
                                    </div>
                                )}
                                <div title="Vendor Name" className="flex-column form-group-selectt" style={{

                                    alignContent: 'flex-start',
                                    justifyItems: 'center',
                                    flexWrap: 'wrap',
                                    paddingTop: '42px',
                                }}>
                                    <button type="button" className="upload-svg" onClick={handleAddVendor}>
                                        {showForm ? "- Select Existing Vendor" : " + Add New Vendor"}
                                    </button>
                                </div>

                                {showForm && (

                                    <div className="form-flex-wrap">

                                        <div title="name" className="flex-column">
                                            <label htmlFor="name" className="form-labels font-weight500 font-size-subheading">
                                                Vender Name<span className="required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="name"
                                                name="name"
                                                placeholder="Vender Name"
                                                onChange={handleInputChange}
                                                value={formdata2.name}
                                                className={`form-input ${errors.name
                                                    ? "error"
                                                    : inputState.name
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.name && (
                                                <span className="error-message font-size-text ">{errors.name}</span>
                                            )}
                                        </div>

                                        <div title="contact_person" className="flex-column">
                                            <label htmlFor="contact_person" className="form-labels font-weight500 font-size-subheading">
                                                Contact Person
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="contact_person"
                                                name="contact_person"
                                                placeholder="Contact Person"
                                                onChange={handleInputChange}
                                                value={formdata2.contact_person}
                                                className={`form-input ${errors.contact_person
                                                    ? "error"
                                                    : inputState.contact_person
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.contact_person && (
                                                <span className="error-message font-size-text ">{errors.contact_person}</span>
                                            )}
                                        </div>

                                        <div title="sub_Company" className="flex-column form-group-selectt">
                                            <label htmlFor="sub_Company" className="form-labels  font-weight500    font-size-subheading">
                                                Sub Company <span className="required">*</span>
                                            </label>
                                            <br />
                                            <select
                                                id="sub_Company"
                                                name="sub_Company"
                                                value={formdata2.sub_Company}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.sub_Company ? "error" : inputState.sub_Company ? "success" : ""
                                                    }`}
                                            >
                                                <option value="">Select a Sub Company</option>
                                                {sub_CompanyList?.sort((a, b) => a.title.localeCompare(b.company_name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                    {console.log(i)}
                                                    <option value={i.id}>{i.title}</option>
                                                </>))
                                                }
                                            </select>
                                            <div className={`form-group-selection-arrow ${errors.status ? 'error-arrow' : ''}`}>
                                                <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10L16 1.55229L14.5324 0L8 6.8998L1.46964 0L0 1.55229L8 10Z" fill="#1E1E1E" />
                                                </svg>
                                            </div>
                                            <div>
                                                {errors.sub_Company && (
                                                    <span className="error-message font-size-text ">{errors.sub_Company}</span>
                                                )}
                                            </div>
                                        </div>

                                        <div title="address" className="flex-column">
                                            <label htmlFor="address" className="form-labels font-weight500 font-size-subheading">
                                                Vender Address
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="address"
                                                name="address"
                                                placeholder="Vender Address"
                                                onChange={handleInputChange}
                                                value={formdata2.address}
                                                className={`form-input ${errors.address
                                                    ? "error"
                                                    : inputState.address
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.address && (
                                                <span className="error-message font-size-text ">{errors.address}</span>
                                            )}
                                        </div>

                                        <div title="email" className="flex-column">
                                            <label htmlFor="email" className="form-labels font-weight500 font-size-subheading">
                                                Vender Email
                                            </label>
                                            <input
                                                type="email"
                                                maxLength={100}
                                                id="email"
                                                name="email"
                                                placeholder="Vender Email"
                                                onChange={handleInputChange}
                                                value={formdata2.email}
                                                className={`form-input ${errors.email
                                                    ? "error"
                                                    : inputState.email
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.email && (
                                                <span className="error-message font-size-text ">{errors.email}</span>
                                            )}
                                        </div>

                                        <div title="contact_number" className="flex-column">
                                            <label htmlFor="contact_number" className="form-labels font-weight500 font-size-subheading">
                                                Vender Number
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="contact_number"
                                                name="contact_number"
                                                placeholder="Client Number"
                                                onChange={handleInputChange}
                                                value={formdata2.contact_number}
                                                className={`form-input ${errors.contact_number
                                                    ? "error"
                                                    : inputState.contact_number
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.contact_number && (
                                                <span className="error-message font-size-text ">{errors.contact_number}</span>
                                            )}
                                        </div>

                                        <div title="alt_contact_number" className="flex-column">
                                            <label htmlFor="alt_contact_number" className="form-labels font-weight500 font-size-subheading">
                                                Alternate Contact Number
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="alt_contact_number"
                                                name="alt_contact_number"
                                                placeholder="Alternate Contact Number"
                                                onChange={handleInputChange}
                                                value={formdata2.alt_contact_number}
                                                className={`form-input ${errors.alt_contact_number
                                                    ? "error"
                                                    : inputState.alt_contact_number
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.alt_contact_number && (
                                                <span className="error-message font-size-text ">{errors.alt_contact_number}</span>
                                            )}
                                        </div>

                                        <div title="gstin_number" className="flex-column">
                                            <label htmlFor="gstin_number" className="form-labels font-weight500 font-size-subheading">
                                                Vender GST Number<span className="required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="gstin_number"
                                                name="gstin_number"
                                                placeholder="Vender GST Number"
                                                onChange={handleInputChange}
                                                value={formdata2.gstin_number}
                                                className={`form-input ${errors.gstin_number
                                                    ? "error"
                                                    : inputState.gstin_number
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.gstin_number && (
                                                <span className="error-message font-size-text ">{errors.gstin_number}</span>
                                            )}
                                        </div>

                                        <div title="pos" className="flex-column">
                                            <label htmlFor="pos" className="form-labels font-weight500 font-size-subheading">
                                                Place of Supply (POS)<span className="required">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                maxLength={100}
                                                id="pos"
                                                name="pos"
                                                placeholder="Place of Supply"
                                                onChange={handleInputChange}
                                                value={formdata2.pos}
                                                className={`form-input ${errors.pos
                                                    ? "error"
                                                    : inputState.pos
                                                        ? "success"
                                                        : ""
                                                    }`}
                                            />
                                            {errors.pos && (
                                                <span className="error-message font-size-text ">{errors.pos}</span>
                                            )}
                                        </div>

                                        <div className="button-models-addd">
                                            <button onClick={handleSubmitVendor} className="model-button-add">Add Vender</button>

                                        </div>

                                    </div>
                                )}
                            </>)}









                        </div>


                        <div className="button-models-add">
                            <button onClick={handleSubmit} className="model-button-add">Edit</button>
                            <button

                                // onclick={handleSubmit}

                                className="model-button-cancel">Cancel</button>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

const DepartmentDelete = ({ i, projectID, getDepartmentList }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/project-details/highwaydepartment/${i.id}/`
            );

            if (res.status === 200 || res.status === 201) {
                await getDepartmentList();
                setShow(false);
            } else {
                // ;
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Insurance"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Departrtment {i.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Departrtment  {i.name}
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};

const ActivityDelete = ({ i, projectID, getDepartmentList }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/project-details/activitytype/${i.id}/`
            );

            if (res.status === 200 || res.status === 201) {
                await getDepartmentList();
                setShow(false);
            } else {
                // ;
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Insurance"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Active {i.activity_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Activity  {i.activity_name}
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};



const CriticalActivityModal = ({ projectID, getCriticalList }) => {
    const [formData, setFormData] = useState({
        critical_activity_name: '',
        description: '',
        reason: '',
        action_to_taken: '',
        duration_time: '',
        issue_raised_on: '',
        project: projectID ? projectID : "",
    });

    const [show, SetShow] = useState(false)
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [loading, setLoading] = useState(false)
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Update input state for styling
        setInputState(prev => ({
            ...prev,
            [name]: value ? "green" : ""
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.critical_activity_name.trim()) {
            newErrors.critical_activity_name = 'Critical Activity Name is required';
        }

        if (!formData.description.trim()) {
            newErrors.description = 'Description is required';
        }

        if (!formData.reason.trim()) {
            newErrors.reason = 'Reason is required';
        }

        if (!formData.action_to_taken.trim()) {
            newErrors.action_to_taken = 'Action to be taken is required';
        }

        if (!formData.duration_time.trim()) {
            newErrors.duration_time = 'Duration time is required';
        }

        if (!formData.issue_raised_on.trim()) {
            newErrors.issue_raised_on = 'Issue raised date is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleShow = () => {
        SetShow(true)
    }

    const handleFormSubmit = async (e) => {
        console.log("clicked")
        e.preventDefault();
        const newerror = {};

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {

                let res = await axios.post(
                    `${BASE_URL}/project_details/criticalactivities/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log(res, "res of critical activity")

                if (res.status === 201 || res.status === 200) {
                    // SetShow(false);
                    handleClose();
                    await getCriticalList();
                    toast.success("Actvity added successfully!");
                    // setFormData(() =>
                    //     Object.keys(formData).reduce((acc, key) => {
                    //         acc[key] = "";
                    //         return acc;
                    //     }, {})
                    // );

                    setErrors({});
                    setLoading(false);

                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleClose = () => {

        SetShow(false)
    };

    return (
        <>       <button
            title="Add Critical Activity"
            className="upload-svg"
            onClick={handleShow}
        >
            <AddwithWhiteCircle /> Add Critical Activity
        </button>
            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Add Critical Activity</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Critical Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Critical Activity Name"
                                    name="critical_activity_name"
                                    value={formData.critical_activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.critical_activity_name ? 'error' : inputState.critical_activity_name ? 'success' : ''}`}
                                />
                                {errors.critical_activity_name && <span className="error-message">{errors.critical_activity_name}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Description <span className="required">*</span></label>
                                <textarea
                                    placeholder="Enter description"
                                    name="description"
                                    rows="3"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.description ? 'error' : inputState.description ? 'success' : ''}`}
                                />
                                {errors.description && <span className="error-message">{errors.description}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Reason <span className="required">*</span></label>
                                <textarea
                                    placeholder="Enter reason"
                                    name="reason"
                                    rows="2"
                                    value={formData.reason}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.reason ? 'error' : inputState.reason ? 'success' : ''}`}
                                />
                                {errors.reason && <span className="error-message">{errors.reason}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Action to be Taken <span className="required">*</span></label>
                                <textarea
                                    placeholder="Enter action to be taken"
                                    name="action_to_taken"
                                    rows="3"
                                    value={formData.action_to_taken}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.action_to_taken ? 'error' : inputState.action_to_taken ? 'success' : ''}`}
                                />
                                {errors.action_to_taken && <span className="error-message">{errors.action_to_taken}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Duration Time <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="e.g., 2 hours, 3 days"
                                    name="duration_time"
                                    value={formData.duration_time}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.duration_time ? 'error' : inputState.duration_time ? 'success' : ''}`}
                                />
                                {errors.duration_time && <span className="error-message">{errors.duration_time}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Issue Raised On <span className="required">*</span></label>
                                <div className="input-wrapper">
                                    <input
                                        type="date"
                                        name="issue_raised_on"
                                        value={formData.issue_raised_on}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.issue_raised_on ? 'error' : inputState.issue_raised_on ? 'success' : ''}`}
                                    />

                                </div>
                                {errors.issue_raised_on && <span className="error-message">{errors.issue_raised_on}</span>}
                            </div>
                        </div>

                        <div className="button-models-add">
                            <button onClick={handleFormSubmit} className="model-button-add">Add</button>
                            <button onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal></>

    );
};

const CriticalEditActivityModal = ({ i, projectID, getCriticalList }) => {
    const [formData, setFormData] = useState({
        critical_activity_name: '',
        description: '',
        reason: '',
        action_to_taken: '',
        duration_time: '',
        issue_raised_on: '',
        project_detail: projectID ? projectID : "",
    });
    const [show, SetShow] = useState(false)
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [loading, setLoading] = useState(false)
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Update input state for styling
        setInputState(prev => ({
            ...prev,
            [name]: value ? "green" : ""
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        // if (!formData.critical_activity_name.trim()) {
        //     newErrors.critical_activity_name = 'Critical Activity Name is required';
        // }

        // if (!formData.description.trim()) {
        //     newErrors.description = 'Description is required';
        // }

        // if (!formData.reason.trim()) {
        //     newErrors.reason = 'Reason is required';
        // }

        // if (!formData.action_to_taken.trim()) {
        //     newErrors.action_to_taken = 'Action to be taken is required';
        // }

        // if (!formData.duration_time.trim()) {
        //     newErrors.duration_time = 'Duration time is required';
        // }

        // if (!formData.issue_raised_on.trim()) {
        //     newErrors.issue_raised_on = 'Issue raised date is required';
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleShow = () => {
        SetShow(true)
        setFormData(i)
    }

    const handleFormSubmit = async (e) => {
        console.log("clicked")
        e.preventDefault();
        const newerror = {};

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {









                let res = await axios.put(
                    `${BASE_URL}/project_details/criticalactivities/${i?.id}/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (res.status === 200) {
                    SetShow(false);
                    setFormData(() =>
                        Object.keys(formData).reduce((acc, key) => {
                            acc[key] = "";
                            return acc;
                        }, {})
                    );

                    setErrors({});
                    setLoading(false);
                    await getCriticalList();
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleClose = () => {

        SetShow(false)
    };

    return (
        <>

            <button onClick={handleShow} className="model-edit-button" title="Edit Critical Activity">
                <UpdatePencil />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Add Critical Activity</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Critical Activity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Critical Activity Name"
                                    name="critical_activity_name"
                                    value={formData.critical_activity_name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.critical_activity_name ? 'error' : inputState.critical_activity_name ? 'success' : ''}`}
                                />
                                {errors.critical_activity_name && <span className="error-message">{errors.critical_activity_name}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Description <span className="required">*</span></label>
                                <textarea
                                    placeholder="Enter description"
                                    name="description"
                                    rows="3"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.description ? 'error' : inputState.description ? 'success' : ''}`}
                                />
                                {errors.description && <span className="error-message">{errors.description}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Reason <span className="required">*</span></label>
                                <textarea
                                    placeholder="Enter reason"
                                    name="reason"
                                    rows="2"
                                    value={formData.reason}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.reason ? 'error' : inputState.reason ? 'success' : ''}`}
                                />
                                {errors.reason && <span className="error-message">{errors.reason}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Action to be Taken <span className="required">*</span></label>
                                <textarea
                                    placeholder="Enter action to be taken"
                                    name="action_to_taken"
                                    rows="3"
                                    value={formData.action_to_taken}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.action_to_taken ? 'error' : inputState.action_to_taken ? 'success' : ''}`}
                                />
                                {errors.action_to_taken && <span className="error-message">{errors.action_to_taken}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Duration Time <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="e.g., 2 hours, 3 days"
                                    name="duration_time"
                                    value={formData.duration_time}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.duration_time ? 'error' : inputState.duration_time ? 'success' : ''}`}
                                />
                                {errors.duration_time && <span className="error-message">{errors.duration_time}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Issue Raised On <span className="required">*</span></label>
                                <div className="input-wrapper">
                                    <input
                                        type="date"
                                        name="issue_raised_on"
                                        value={formData.issue_raised_on}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.issue_raised_on ? 'error' : inputState.issue_raised_on ? 'success' : ''}`}
                                    />

                                </div>
                                {errors.issue_raised_on && <span className="error-message">{errors.issue_raised_on}</span>}
                            </div>
                        </div>

                        <div className="button-models-add">
                            <button onClick={handleFormSubmit} className="model-button-add">Edit</button>
                            <button onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal></>

    );
};

const CriticalActivityModalDelete = ({ i, projectID, getCriticalList }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/project_details/criticalactivities/${i.id}/`
            );

            if (res.status === 200 || res.status === 201) {
                await getCriticalList();
                setShow(false);
            } else {
                // ;
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Critical Activity"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="half-modal-new"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Critical Activity {i.activity_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Critical Activity  {i.activity_name}
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={() => handleClose()}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};

const ProductionModalAdd = ({ projectID, getProductionList }) => {
    const [formData, setFormData] = useState({
        name: "",
        quantity: "",
        project: projectID ? projectID : "",
    });
    const [show, SetShow] = useState(false)
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [loading, setLoading] = useState(false)
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Update input state for styling
        setInputState(prev => ({
            ...prev,
            [name]: value ? "green" : ""
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = ' Name is required';
        }

        if (!formData.quantity.trim()) {
            newErrors.quantity = 'Quantity is required';
        }



        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleShow = () => {
        SetShow(true)
    }

    const handleFormSubmit = async (e) => {

        e.preventDefault();
        const newerror = {};

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);

            try {

                let res = await axios.post(
                    `${BASE_URL}/project_details/productions/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log(res, "resproductuionnnnnn")
                if (res.status === 201 || res.status === 200) {

                    handleClose()
                    await getProductionList();
                    toast.success("Production added successfully!");
                    // SetShow(false);
                    // setFormData(() =>
                    //     Object.keys(formData).reduce((acc, key) => {
                    //         acc[key] = "";
                    //         return acc;
                    //     }, {})
                    // );

                    setErrors({});
                    setLoading(false);
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleClose = () => {

        SetShow(false)
    };

    return (
        <>       <button
            title="Add Production"
            className="upload-svg"
            onClick={handleShow}
        >
            <AddwithWhiteCircle /> Add Production
        </button>
            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Add Production</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Prodcution Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Production Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.name ? 'error' : inputState.name ? 'success' : ''}`}
                                />
                                {errors.name && <span className="error-message">{errors.name}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Quantity <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Production Name"
                                    name="quantity"
                                    value={formData.quantity}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.quantity ? 'error' : inputState.quantity ? 'success' : ''}`}
                                />
                                {errors.quantity && <span className="error-message">{errors.quantity}</span>}
                            </div>


                        </div>

                        <div className="button-models-add">
                            <button onClick={handleFormSubmit} className="model-button-add">Add</button>
                            <button onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal></>

    );
};

const ProductionModalEdit = ({ i, projectID, getProductionList }) => {
    const [formData, setFormData] = useState({
        name: "",
        quantity: "",
        project: projectID ? projectID : "",
    });
    const [show, SetShow] = useState(false)
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [loading, setLoading] = useState(false)
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Update input state for styling
        setInputState(prev => ({
            ...prev,
            [name]: value ? "green" : ""
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = ' Name is required';
        }

        // if (!formData.quantity.trim()) {
        //     newErrors.quantity = 'Quantity is required';
        // }

        if (!formData.quantity || formData.quantity.toString().trim() === "") {
            newErrors.quantity = "Quantity is required";
        }


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleShow = () => {
        setFormData(i)
        SetShow(true)
    }

    const handleFormSubmit = async (e) => {
        console.log("clicked")
        e.preventDefault();
        const newerror = {};

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");
            setLoading(true);
            try {

                let res = await axios.put(
                    `${BASE_URL}/project_details/productions/${i.id}/`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (res.status === 200) {
                    SetShow(false);

                    setLoading(false);
                    await getProductionList();
                    // setFormData(() =>
                    //     Object.keys(formData).reduce((acc, key) => {
                    //         acc[key] = "";
                    //         return acc;
                    //     }, {})
                    // );

                    setErrors({});
                } else {
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    const handleClose = () => {
        SetShow(false)
    };

    return (
        <>           <button onClick={handleShow} className="model-edit-button" title="Edit Production">
            <UpdatePencil />

        </button>
            <Modal show={show} onHide={handleClose} dialogClassName="half-modal-new">
                <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title><h4 className="heading-name">Add Production</h4></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="add-activity">
                        <div className='form-flex-wrap'>
                            <div className="flex-column">
                                <label className="form-labels">Prodcution Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Production Name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.name ? 'error' : inputState.name ? 'success' : ''}`}
                                />
                                {errors.name && <span className="error-message">{errors.name}</span>}
                            </div>

                            <div className="flex-column">
                                <label className="form-labels">Quantity <span className="required">*</span></label>
                                <input
                                    type="text"
                                    placeholder="Enter Production Name"
                                    name="quantity"
                                    value={formData.quantity}
                                    onChange={handleInputChange}
                                    className={`activity-form form-input ${errors.quantity ? 'error' : inputState.quantity ? 'success' : ''}`}
                                />
                                {errors.quantity && <span className="error-message">{errors.quantity}</span>}
                            </div>


                        </div>

                        <div className="button-models-add">
                            <button onClick={handleFormSubmit} className="model-button-add">Edit</button>
                            <button onClick={handleClose} className="model-button-cancel">Cancel</button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal></>

    );
};

const ProductionModalDelete = ({ i, projectID, getProductionList }) => {
    const [show, setShow] = useState(false);
    // console.log(i)
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(
                `${BASE_URL}/project_details/productions/${i.id}/`
            );

            if (res.status === 200 || res.status === 201) {
                await getProductionList();
                setShow(false);
            } else {
                // ;
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Critical Activity"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="half-modal-new"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Prodcution {i.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Critical Activity  {i.name}
                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={() => handleClose()}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    );
};


export { AddActivity, AddDepartment, AddEditProjectDepartment, EditActivity, EditDepartment, DepartmentDelete, ActivityDelete, CriticalActivityModal, CriticalEditActivityModal, CriticalActivityModalDelete, ProductionModalAdd, ProductionModalEdit, ProductionModalDelete }